import * as React from "react";
import { usePerformAction } from "react-remote-data-hooks";
import api from "../../../../api";
import { SocialMediaLink } from "../../../../core";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";
import UpdateForm from "./UpdateForm";
import { useStateWithCallbackLazy } from "use-state-with-callback";

interface ISocialMediaLinksProps {
  data?: SocialMediaLink[];
  reload?: () => void;
}

const SocialMediaLinksTab: React.FunctionComponent<ISocialMediaLinksProps> = (
  props
) => {
  const appSettings = useAppSettings(api.settings);

  const [editModal, setEditModal] = useStateWithCallbackLazy<{
    open?: boolean;
    index?: number;
  }>({});
  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: { socialMediaLinks: SocialMediaLink[] }) =>
      api.settings.updateSocialMediaLinks(data),
    () => {
      setEditModal({}, () => {
        props.reload?.();
      });
      appSettings.reload();
    }
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Social Media Links</h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => {
                setEditModal({}, () => {
                  setEditModal({ open: true }, () => {
                    // console.log("model closed")
                  });
                });
              }}
            >
              <i className="icon-plus mr-1 font-xs"></i> Add
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Name</span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Social Media Link
                  </span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Social Media Icon Url
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {props.data?.map((d, index) => (
                <tr
                  onClick={() => {
                    setEditModal({}, () => {
                      setEditModal({ open: true, index }, () => {
                        // console.log("model closed")
                      });
                    });
                  }}
                  className="cursor-pointer"
                >
                  <td>{d.name}</td>
                  <td>{d.url}</td>
                  <td>{d.imageUrl}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModal?.open && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              key={editModal.index || "new"}
              onSubmit={(formData) => {
                const newData = [...(props.data || [])];
                if (editModal.index !== undefined) {
                  newData[editModal.index] = formData;
                } else {
                  newData.push(formData);
                }
                update({ socialMediaLinks: newData });
              }}
              isSubmitting={updating}
              error={updateError?.message}
              data={
                editModal.index !== undefined
                  ? props.data?.[editModal.index]
                  : undefined
              }
              onCancel={() =>
                setEditModal({}, () => {
                  // console
                })
              }
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default SocialMediaLinksTab;
